<template>
  <div>
    <div v-if="!isBE">
      <h4 id="address" >{{ venueLocationText }}</h4>
      <p class="small">{{ vaddress }}</p>
    </div>

    <div v-else class="contactUsSection" style="display:none">
      <div v-show="false" class="contactUsItem fullWidth" >
        <h4 class="title">{{ strings.contactus }}</h4>
      </div>
      <div class="contactUsItem" v-show="false">
        <font-awesome-icon :icon="['fas', 'phone-alt']" size="2x" />
        <span class="text"> {{ venuePhoneNumber }} </span>
      </div>
      <div class="contactUsItem" v-show="false">
        <font-awesome-icon :icon="['fas', 'envelope']" size="2x" />
        <span class="text"> {{ venueEmail }} </span>
      </div>
      <div class="contactUsItem" v-show="false">
        <font-awesome-icon :icon="['fas', 'map-marker-alt']" size="2x" />
        <span class="text"> {{ vaddress }}</span>
      </div>
    </div>
    <iframe
      :src="source"
      width="100%"
      height="420"
      title="Venue Map"
      frameborder="0"
      class="map"
      allowfullscreen
      v-if="vaddress != ''"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //key : 'AIzaSyDAQ7ciBDWcove0GrwiXHJKsyFSy9XqmQ8', // This is the test key.
      key: 'AIzaSyDouUaXN6myEhlX8xGWD5Aj9lUGnqFbQ3Q', // This is the production key.
      vaddress: ''
    }
  },
  props: ['strings', 'fulladdress'],
  watch: {
    fulladdress: function(value) {
      this.vaddress = value
    }
  },
  computed: {
    isBE(){
      return this.$store.state.isBE;
    },
    venueLocationText() {
      return window.location.hostname == 'devere.meetingpackage.com'
        ? this.$store.state.strings.location
        : this.$store.state.strings.venuelocation
    },
    venueEmail() {
      return this.$store.state.venueInfo.venue_email
    },
    venuePhoneNumber() {
      return this.$store.state.venueInfo.venue_phone_number
    },
    source() {
      let newAddress = this.vaddress.replace(/ /g, '+')
      let source =
        'https://www.google.com/maps/embed/v1/place?key=' +
        this.key +
        '&language=' +
        this.$store.state.selectedLang +
        '&q=' +
        encodeURIComponent(newAddress)
      return source
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 25px;
  padding: 0 0 0.5em 0;
  margin: 0;
}
.contactUsSection {
  background: #fff;
  display: flex;
  min-height: 120px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1.8em 20px 1.8em 20px;
  border-radius: 5px;
}
.contactUsItem {
  display: inline-flex;
  max-width: 30%;
  align-items: center;
}
.fullWidth {
  width: 100%;
  max-width: 100%;
}

.text {
  font-size: 18px;
  margin-left: 0.7em;
}
@media (max-width: 960px) {
  .contactUsItem {
    width: 100%;
    max-width: 100%;
    padding-top: 18px;
  }
}
</style>
